module.exports = require("./data/data.json")
